import { render, staticRenderFns } from "./track-history.vue?vue&type=template&id=3506d222&"
import script from "./track-history.component.ts?vue&type=script&lang=ts&"
export * from "./track-history.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports